/* angular:styles/component:css;457005cfade8e8dd1474137f84123c54611f5b9eda83a726ce41fcd524dd2a3b;/Users/daniyal/Cuboid AS Dropbox/Daniyal Ahmed/Development/friggkantine-admin/projects/portal/src/app/pages/employees/ledger-dialog.component.ts */
.balance {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 14px;
}
.balance-label {
  font-size: 12px;
  color: #8593a1;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.balance-value {
  font-size: 20px;
  font-weight: 600;
  color: #16324f;
}
.neg {
  color: #b3271e;
}
/*# sourceMappingURL=ledger-dialog.component.css.map */
